import React from 'react';
import { useTranslation } from 'react-i18next';
import './tenant.css';

// «Kimga» filtri: Oila / Talaba (→ O'g'il / Qiz) + necha kishi. Bosh sahifa va e'lonlar ro'yxatida umumiy.
// tenant: '' | FAMILY | STUDENT (istalgan talaba) | STUDENT_MALE | STUDENT_FEMALE; people: '' | '1'..'4' (4 = 4+)
export const TENANT_LABELS = { FAMILY: 'Oilaga', STUDENT_MALE: 'Talaba yigitlarga', STUDENT_FEMALE: 'Talaba qizlarga' };

/** E'londagi tenantTypes → qisqa yozuv: "Oilaga · Talabalarga" */
export function tenantText(types, t) {
  if (!types?.length) return '';
  const both = types.includes('STUDENT_MALE') && types.includes('STUDENT_FEMALE');
  return [
    types.includes('FAMILY') && t('Oilaga'),
    both ? t('Talabalarga') : types.includes('STUDENT_MALE') ? t('Talaba yigitlarga') : types.includes('STUDENT_FEMALE') ? t('Talaba qizlarga') : null,
  ].filter(Boolean).join(' · ');
}

export default function TenantFilter({ tenant = '', people = '', onChange }) {
  const { t } = useTranslation();
  const student = tenant.startsWith('STUDENT');
  const Pill = ({ on, onClick, children }) => (
    <button type='button' className={`tf-pill${on ? ' on' : ''}`} aria-pressed={on} onClick={onClick}>{children}</button>
  );
  return (
    <div className='tf'>
      <div className='tf-row' role='group' aria-label={t('Kimga')}>
        <span className='tf-lbl'>{t('Kimga')}</span>
        <Pill on={!tenant} onClick={() => onChange({ tenant: '' })}>{t("Farqi yo'q")}</Pill>
        <Pill on={tenant === 'FAMILY'} onClick={() => onChange({ tenant: tenant === 'FAMILY' ? '' : 'FAMILY' })}>{t('Oila')}</Pill>
        <Pill on={student} onClick={() => onChange({ tenant: student ? '' : 'STUDENT' })}>{t('Talaba')}</Pill>
      </div>
      {student && (
        <div className='tf-row tf-sub' role='group' aria-label={t('Talaba')}>
          <Pill on={tenant === 'STUDENT'} onClick={() => onChange({ tenant: 'STUDENT' })}>{t('Hammasi')}</Pill>
          <Pill on={tenant === 'STUDENT_MALE'} onClick={() => onChange({ tenant: 'STUDENT_MALE' })}>{t("O'g'il bola")}</Pill>
          <Pill on={tenant === 'STUDENT_FEMALE'} onClick={() => onChange({ tenant: 'STUDENT_FEMALE' })}>{t('Qiz bola')}</Pill>
        </div>
      )}
      <div className='tf-row' role='group' aria-label={t('Necha kishi')}>
        <span className='tf-lbl'>{t('Necha kishi')}</span>
        {['1', '2', '3', '4'].map(n => (
          <Pill key={n} on={people === n} onClick={() => onChange({ people: people === n ? '' : n })}>{n === '4' ? '4+' : n}</Pill>
        ))}
      </div>
    </div>
  );
}
